import axios from 'axios'

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL
        ? `${process.env.REACT_APP_API_URL}/api`
        : 'http://localhost:3000/api'
})

export default api